import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "seismic-view-3d-root" }
const _hoisted_2 = { class: "button-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "button-group"
}
const _hoisted_5 = { for: "inlineSelect" }
const _hoisted_6 = ["min", "max", "step"]
const _hoisted_7 = {
  key: 1,
  class: "button-group"
}
const _hoisted_8 = { for: "xlineSelect" }
const _hoisted_9 = ["min", "max", "step"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_11 = {
  ref: "plotContainer3D",
  class: "plot-container-3d"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.traceBounds)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(`Inline (${_ctx.traceBounds.threeDeeRange.inlineRange.min} - ${_ctx.traceBounds.threeDeeRange.inlineRange.max}):`), 1),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              id: "inlineSelect",
              name: "inline",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedInline) = $event)),
              min: _ctx.traceBounds.threeDeeRange.inlineRange.min,
              max: _ctx.traceBounds.threeDeeRange.inlineRange.max,
              step: _ctx.traceBounds.threeDeeRange.inlineRange.step
            }, null, 8, _hoisted_6), [
              [
                _vModelText,
                _ctx.selectedInline,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addInline && _ctx.addInline(...args)))
            }, "Show"),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideInline && _ctx.hideInline(...args)))
            }, "Hide")
          ]))
        : _createCommentVNode("", true),
      (_ctx.traceBounds)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(`Crossline (${_ctx.traceBounds.threeDeeRange.crosslineRange.min} - ${_ctx.traceBounds.threeDeeRange.crosslineRange.max}):`), 1),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              id: "xlineSelect",
              name: "xline",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedXline) = $event)),
              min: _ctx.traceBounds.threeDeeRange.crosslineRange.min,
              max: _ctx.traceBounds.threeDeeRange.crosslineRange.max,
              step: _ctx.traceBounds.threeDeeRange.crosslineRange.step
            }, null, 8, _hoisted_9), [
              [
                _vModelText,
                _ctx.selectedXline,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addxLine && _ctx.addxLine(...args)))
            }, "Show"),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hidexLine && _ctx.hidexLine(...args)))
            }, "Hide")
          ]))
        : _createCommentVNode("", true),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, null, 512)
  ]))
}